<template>
  <el-dialog
    title="查看客户信息"
    :visible.sync="currentVisible"
    width="50%">
    <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="任务ID"
                          prop="task_id">
              <span>{{customer.task_id}}</span>
            </el-form-item>
            <el-form-item label="姓名"
                          prop="name">
              <span>{{customer.username}}</span>
            </el-form-item>
            <el-form-item label="电话"
                          prop="name">
              <span>{{customer.cellphone}}</span>
            </el-form-item>
            <el-form-item :label="key"
                          prop="name" v-for="(value, key) in customer.variables" :key="key">
              <span>{{value}}</span>
            </el-form-item>
          </div>
        </div>
      </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button el-button @click="currentVisible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    customer: {
      type: Object
    }
  },
  data () {
    return {
      form: {},
      currentVisible: this.visible,
    }
  },
  computed: {},
  watch: {
    visible () {
      if (this.currentVisible !== this.visible) {
        this.currentVisible = this.visible
      }
    },
    currentVisible () {
      if (this.currentVisible !== this.visible) {
        this.$emit('update:visible', this.currentVisible)
      }
    },
  },
  created () {},
  mounted () {},
  methods: {
    onSubmit () {
      this.currentVisible = false
      this.$message.success('提交成功！')
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/intelligent-outbound-call/components/CustomerInfoDialog.vue